/** Compatibility export; the headless package owns this contract. */
export * from '@galapagos/catalog-schema/elements/sizing';
